<script>
import { defineComponent } from 'vue'
import NotificationService from '@/services/header/NotificationService'
import { handleResponseError } from '@/components/utils/globalFunction'
import NotificationWidget from '@/components/header/NotificationWidget.vue'

export default defineComponent({
  name: 'NotificationBell',
  components: { NotificationWidget },
  data() {
    return {
      loading: false,
      notificationCount: 0
    }
  },
  async created() {
    await this.getNotificationCount()
  },
  methods: {
    async getNotificationCount() {
      this.loading = true
      try {
        const responseNotificationDto = await NotificationService.getNotificationCount()
        this.notificationCount = responseNotificationDto.count
      } catch (error) {
        handleResponseError(error)
      } finally {
        this.loading = false
      }
    }
  }
})
</script>

<template>
  <v-menu location="bottom right" offset="4" :close-on-content-click="false">
    <template v-slot:activator="{ props, isActive }">
      <v-btn v-bind="props" class="nav-btn" icon :class="isActive ? 'active-notification' : ''">
        <v-badge
          v-if="notificationCount > 0"
          :content="notificationCount"
          color="var(--warning-color)"
          offset-x="-2"
          text-color="#ffffff"
        >
          <v-icon icon="mdi-bell-outline" :style="{ color: isActive ? 'white' : '#165039' }" />
        </v-badge>
        <v-icon
          v-if="notificationCount === 0"
          icon="mdi-bell-outline"
          :style="{ color: isActive ? 'white' : '#165039' }"
        />
      </v-btn>
    </template>

    <NotificationWidget @refresh-count="getNotificationCount" />
  </v-menu>
</template>

<style scoped>
.active-notification {
  background-color: #559a1b !important;
}
</style>
